var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-103 0 512 512.0005",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4286,
    stopColor: "#ffbb23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa700"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 49.1792184036,
    x2: 324.4296331458,
    xlinkHref: "#a",
    y1: 290.6156417366,
    y2: 455.4546145266
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 152.8302496078,
    x2: 152.8302496078,
    xlinkHref: "#a",
    y1: 197.8074700934,
    y2: 235.6474989018
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0206,
    stopColor: "#fea600",
    stopOpacity: 0.019608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    stopColor: "#ec8c00",
    stopOpacity: 0.635294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e58200"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 239.3795699342,
    x2: 106.4540728178,
    xlinkHref: "#d",
    y1: 333.8137026512,
    y2: 109.2993975528
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 307.111577077,
    x2: 242.9500185272,
    xlinkHref: "#d",
    y1: 262.505022599,
    y2: 196.9331544236
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 222.2136080484,
    x2: 124.4431503514,
    xlinkHref: "#d",
    y1: 432.3427238114,
    y2: 334.5723665066
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0633,
    stopColor: "#37355a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#232543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#171b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 140.0430943094,
    x2: 189.4528222068,
    xlinkHref: "#h",
    y1: 329.8175911302,
    y2: 421.262235913
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 152.83035,
    x2: 152.83035,
    xlinkHref: "#h",
    y1: 174.307463133,
    y2: 246.591353016
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 152.83035,
    x2: 152.83035,
    xlinkHref: "#d",
    y1: 461.9861310586,
    y2: 516.4466909302
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m288.820312 493.558594c-90.078124 24.589844-181.90625 24.589844-271.980468 0-9.953125-2.71875-16.839844-11.792969-16.839844-22.113282v-237.515624c0-10.316407 6.886719-19.390626 16.839844-22.109376 90.070312-24.589843 181.90625-24.589843 271.980468 0 9.953126 2.71875 16.839844 11.792969 16.839844 22.109376v237.519531c0 10.316406-6.886718 19.390625-16.839844 22.109375zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m284.148438 210.585938c-1.839844-.484376-3.679688-.964844-5.519532-1.429688-1.238281-.308594-2.476562-.613281-3.714844-.914062-1.789062-.441407-3.578124-.867188-5.371093-1.289063-1.253907-.292969-2.507813-.578125-3.761719-.863281-1.792969-.40625-3.585938-.796875-5.378906-1.183594-1.238282-.265625-2.476563-.53125-3.714844-.789062-1.847656-.382813-3.699219-.75-5.550781-1.113282-1.175781-.230468-2.347657-.464844-3.523438-.6875-2.03125-.382812-4.0625-.746094-6.089843-1.105468-.992188-.175782-1.984376-.359376-2.976563-.53125-3.019531-.515626-6.039063-1.007813-9.058594-1.464844-.054687-.007813-.109375-.015625-.164062-.027344-2.96875-.449219-5.9375-.871094-8.90625-1.269531-1-.136719-2-.253907-2.996094-.382813-2.03125-.261718-4.0625-.515625-6.09375-.753906-1.179687-.136719-2.359375-.261719-3.539063-.390625-1.855468-.203125-3.714843-.398437-5.570312-.582031-1.242188-.121094-2.484375-.234375-3.730469-.347656-1.800781-.164063-3.605469-.320313-5.410156-.460938-1.261719-.101562-2.527344-.199219-3.789063-.289062-1.796874-.128907-3.597656-.25-5.398437-.359376-1.25-.078124-2.5-.15625-3.746094-.222656-1.859375-.101562-3.71875-.183594-5.574219-.265625-1.179687-.050781-2.363281-.105469-3.539062-.148437-2.042969-.074219-4.082031-.125-6.121094-.175782-.996094-.023437-1.992187-.058593-2.988281-.074218-3.027344-.054688-6.0625-.085938-9.089844-.085938h-.003906c-3.03125 0-6.0625.03125-9.089844.085938-.996093.019531-1.996093.050781-2.992187.074218-2.039063.050782-4.074219.101563-6.113282.175782-1.179687.042968-2.363281.097656-3.542968.148437-1.859375.082031-3.71875.164063-5.574219.265625-1.246094.066406-2.496094.144532-3.742187.222656-1.800782.109376-3.601563.230469-5.402344.359376-1.265625.089843-2.527344.1875-3.789063.289062-1.804687.140625-3.609375.300781-5.410156.460938-1.242187.113281-2.484375.226562-3.730469.347656-1.855468.179687-3.714844.378906-5.570312.582031-1.179688.128906-2.359375.253906-3.539063.390625-2.03125.234375-4.0625.492188-6.09375.753906-.996093.128906-1.996093.246094-2.992187.378906-2.96875.398438-5.933594.820313-8.898438 1.273438-.058594.007812-.117187.015625-.175781.023438-3.019531.460937-6.039063.953124-9.054687 1.46875-.992188.167968-1.984376.355468-2.976563.53125-2.03125.359374-4.0625.722656-6.09375 1.105468-1.171875.222656-2.34375.457032-3.515625.6875-1.855469.363282-3.707031.730469-5.558594 1.113282-1.238281.257812-2.476562.523437-3.714844.789062-1.792968.386719-3.582031.777344-5.371093 1.183594-1.257813.28125-2.515625.570312-3.773438.863281-1.789062.417969-3.574219.847656-5.363281 1.285156-1.238281.300781-2.476562.605469-3.714844.917969-1.839844.460938-3.679687.945312-5.519531 1.429688-1.175781.308593-2.347656.613281-3.519531.929687-.519532.140625-1.035156.289063-1.554688.429687-5.519531 1.617188-10.058594 5.195313-12.957031 9.851563 98.789063 29.699219 199.910156 29.699219 298.703125 0-2.902344-4.65625-7.441406-8.234375-12.960938-9.851563-.515624-.140624-1.035156-.289062-1.554687-.429687-1.175781-.316406-2.351563-.621094-3.523437-.929687zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m288.820312 211.820312c-82.515624-22.527343-166.503906-24.402343-249.261718-5.65625v2.898438c0 6.816406 3.484375 12.820312 8.761718 16.335938l255.363282 255.359374c1.273437-2.867187 1.976562-6.023437 1.976562-9.308593v-237.519531c0-10.316407-6.886718-19.390626-16.839844-22.109376zm0 0",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m305.660156 233.929688c0-10.316407-6.886718-19.390626-16.839844-22.109376-20.542968-5.609374-41.171874-9.933593-61.855468-12.984374v10.226562c0 6.816406 3.484375 12.820312 8.765625 16.335938l69.929687 69.929687zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m279.140625 414.828125-96.660156-96.660156c-8.03125-8.542969-19.707031-13.625-32.550781-12.734375-20.027344 1.386718-36.261719 17.589844-37.691407 37.613281-.917969 12.882813 4.179688 24.59375 12.753907 32.636719l9.660156 9.664062c3.121094 4.757813 4.804687 10.425782 4.804687 16.25v16.660156c0 4.320313 1.992188 8.269532 5.121094 10.832032l78.0625 78.0625c14.078125-1.953125 28.136719-4.5 42.160156-7.640625.070313-8.710938 3.992188-17.066407 10.972657-22.289063 9.921874-7.417968 16.347656-19.253906 16.347656-32.597656 0-11.769531-4.996094-22.367188-12.980469-29.796875zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m193.527344 346.03125c0-23.4375-19.808594-42.246094-43.597656-40.597656-20.027344 1.386718-36.261719 17.589844-37.691407 37.613281-1.027343 14.445313 5.488281 27.425781 16.007813 35.40625 7.1875 5.457031 11.210937 14.121094 11.210937 23.144531v16.660156c0 7.363282 5.761719 13.679688 13.121094 13.8125 7.5.140626 13.625-5.898437 13.625-13.367187v-17.550781c0-8.796875 3.933594-17.253906 10.976563-22.523438 9.921874-7.417968 16.347656-19.257812 16.347656-32.597656zm0 0",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m246.484375 228.679688c-10.832031 0-19.617187-8.785157-19.617187-19.617188v-95.792969c0-40.824219-33.210938-74.035156-74.035157-74.035156-40.828125 0-74.039062 33.210937-74.039062 74.035156v95.792969c0 10.832031-8.785157 19.617188-19.617188 19.617188-10.835937 0-19.617187-8.785157-19.617187-19.617188v-95.792969c0-62.457031 50.8125-113.269531 113.273437-113.269531 62.457031 0 113.269531 50.8125 113.269531 113.269531v95.792969c0 10.832031-8.78125 19.617188-19.617187 19.617188zm0 0",
    fill: "url(#j)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m0 406.242188v65.207031c0 10.316406 6.886719 19.390625 16.84375 22.109375 90.070312 24.589844 181.902344 24.589844 271.976562 0 9.953126-2.71875 16.839844-11.792969 16.839844-22.109375v-65.207031zm0 0",
    fill: "url(#k)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.bb8ad6cd45208ddba5dd3f513654893a.svg";
export { ForwardRef as ReactComponent };